import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import GuidedAdjust from 'components/Sales/Smart/Audit/GuidedAdjust';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { getWarehouseCodeFromCache } from 'utils';

export default function SmartMove(): JSX.Element {
  return (
    <ContentLayout title="Guided Adjustment" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}>
      <GuidedAdjust />
    </ContentLayout>
  );
}
